import React, { useState } from 'react'
import authApi from '../../api/authApi';
import { getErrorMessage, logError } from '../../utils/errorHandler';
import { useNavigate } from 'react-router-dom';
import Topbar from '../layout/Topbar';
import { RotatingLines } from 'react-loader-spinner';
import Countdown from 'react-countdown';

const Register = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [msg, setMsg] = useState('');
    const [kode, setKode] = useState('');
    const [position, setPosition] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [isDisabled, setDisabled] = useState(true);
    const [countdown, setCountdown] = useState(Date.now() + 30000);

    const navigate = useNavigate();

    const submitEmail = async () => {
        setLoading(true)
        setDisabled(true)
        setMsg();
        try {
            const res = await authApi.post('/email', {
                email: email,
                type: 'register',
            })
            console.log(res)
            if (res.status === 200) {
                setPosition(1)
                setCountdown(Date.now() + 30000)
            }
        } catch (error) {
            setLoading(false)
            logError('Gagal mengirim kode verifikasi:', error)
            setMsg(getErrorMessage(error, 'Gagal mengirim kode verifikasi. Silakan coba lagi.'))
        }
        setLoading(false)
        setDisabled(false)
    }

    const submitVerify = async (kode) => {
        try {
            const res = await authApi.post('/verify', {
                email: email,
                code: kode,

            })
            console.log(res)
            setPosition(2);
        } catch (error) {
            setMsg('Kode Verifikasi Tidak Sesuai')
        }
    }

    const Register = async (e) => {
        e.preventDefault();
        setLoading(true)
        setDisabled(true)
        try {
            await authApi.post('/register', {
                code: kode,
                name: name,
                email: email,
                password: password,
                confirm_password: confPassword
            });
            setMsg('Registrasi Berhasil, menuju ke halaman login dalam 5 detik')
            setTimeout(()=>{
                navigate('/login')
            },5000)
        } catch (error) {
            logError('Registrasi gagal:', error)
            setMsg(getErrorMessage(error, 'Registrasi gagal. Silakan periksa data Anda.'))
        }
        setLoading(false)
        setDisabled(false)
    }

    const handleChange = (email) => {
        // don't remember from where i copied this code, but this works.
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (re.test(email)) {
            // this is a valid email address
            // call setState({email: email}) to update the email
            // or update the data in redux store.
            setDisabled(false);
            setMsg('');
        }
        else {
            setDisabled(true);
            setMsg('format email tidak valid');
            // invalid email, maybe show an error to the user.
        }
        setEmail(email);
    }

    const handleChangeKode = (kode) => {
        setMsg()
        setKode(kode)
        if (kode.length === 6) {
            submitVerify(kode);
        }
    }

    // Countdown if complete component
    const Completionist = () => {
        if (!isLoading) {
            return (<span className='has-text-primary is-clickable' onClick={() => submitEmail()}> Kirim Ulang!</span>)
        }
        else {
            return (<></>)
        }
    }

    // Countdown Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a complete state
            return <Completionist />;
        } else {
            // Render a countdown
            return (
                <span> {seconds}</span>
            );
        }
    };

    const renderForm = () => {
        if (position === 0) {
            return (
                <div className='card-content'>
                    <div>
                        <p>Gunakan email yang valid. Kami akan mengirimkan kode verifikasi untuk mengatur password</p>
                        <div className="field mt-5">
                            {/* <label className="label">Email</label> */}
                            <div className="controls">
                                <input type="email" className="input" placeholder='Email'
                                    value={email} onChange={(e) => handleChange(e.target.value)} />
                            </div>
                        </div>
                        <p>{msg}</p>
                        <div className="field mt-5">
                            <button className="button is-fullwidth has-background-primary-30 has-text-white"
                                onClick={() => submitEmail()} disabled={isDisabled}>
                                Lanjut
                            </button>
                        </div>
                    </div>
                </div>
            )
        } else if (position === 1) {
            return (
                <div className='card-content'>
                    <div>
                        <p>Masukkan kode verifikasi yang sudah kami kirim ke email {email} pada kotak berikut.</p>
                        <div className="field mt-5">
                            {/* <label className="label">Email</label> */}
                            <div className="controls">
                                <input type="text" className="input" placeholder=''
                                    value={kode} onChange={(e) => handleChangeKode(e.target.value)} />
                            </div>
                        </div>
                        <p>{msg}</p>
                        <p>Belum menerima email?
                            <Countdown
                                date={countdown}
                                renderer={renderer}
                                key={countdown}
                            />
                        </p>
                    </div>
                </div>
            )
        } else if (position === 2) {
            return (
                <div className="card-content">
                    <p className="has-text-centered">{msg}</p>
                    <div className="field mt-5">
                        <label className="label">Email</label>
                        <div className="controls">
                            <input type="text" className="input" value={email} disabled />
                        </div>
                    </div>
                    <div className="field mt-5">
                        <label className="label">Name</label>
                        <div className="controls">
                            <input type="text" className="input" placeholder='Name'
                                value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                    </div>
                    <div className="field mt-5">
                        <label className="label">Password</label>
                        <div className="controls">
                            <input type="password" className="input" placeholder='********'
                                value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                    </div>
                    <div className="field mt-5">
                        <label className="label">Confirm Password</label>
                        <div className="controls">
                            <input type="password" className="input" placeholder='********'
                                value={confPassword} onChange={(e) => setConfPassword(e.target.value)} />
                        </div>
                    </div>
                    <p className='mt-5'>Dengan lanjut Daftar/Register, berarti Anda telah menyetujui
                        <span className='has-text-primary is-clickable'> Ketentuan Layanan</span> dan
                        <span className='has-text-primary is-clickable'> Kebijakan Privasi</span></p>
                    <div className="field mt-5">
                        <button className="button is-fullwidth has-background-primary-30 has-text-white"
                            onClick={Register} disabled={isDisabled}>
                            Register
                        </button>
                    </div>
                </div>
            )
        }
    }

    return (
        <div>
            <Topbar page={'register'} />
            <div className="container p-5">
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Register</p>
                                <div className='card-header-icon'>
                                    <RotatingLines
                                        visible={isLoading}
                                        height="20"
                                        width="20"
                                        strokeColor="gray"
                                        strokeWidth="5"
                                        animationDuration="0.75"
                                        ariaLabel="rotating-lines-loading"
                                    />
                                </div>
                            </header>
                            {renderForm()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register
